// extracted by mini-css-extract-plugin
export default {"inputs":"styles_inputs__WsF9V","cta":"styles_cta__5gUmf"};